<template>
  <div class="wrap">
    <safeguard-gnb v-if="this.isSub && isSafeguardSite" />
    <gnb v-else-if="this.isSub" class="header-white" />
    <v-container class="py-0">
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2" class="py-0">
          <div v-if="this.isSub" class="sub-header" :class="[subHeaderAlign, { 'sub-header-safeguard': isSafeguardSite }]">
            <div>
              <img class="sub-header-img" v-if="subHeaderColor" :src="require(`@/assets/new/image/subheader/${subHeaderImage}`)" alt="logo" />
              <p class="sub-header-title" v-html="subHeaderTitle" :class="{ text : subHeaderColor }"></p>
              <p class="sub-header-text" v-html="subHeaderText"></p>
              <p v-if="subHeaderCaption" class="sub-header-caption" v-html="subHeaderCaption"></p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div v-if="this.isSub" class="contents">
      <slot :show-terms="showTermDialog" :show-prime-terms="showPrimeTermDialog"/>
    </div>
    <slot v-else></slot>

    <main-footer v-if="this.fixFooter" class="fix-footer" />
    <main-footer v-else-if="this.isSub" />
    <div class="dimmed" ref="dimmed"></div>
    <terms-dialog :is-show="isShowTermsDialog" :term-title="termTitle" :term-content="termContent" :is-external-term="isExternalTerm" :external-term-url="externalTermUrl" :has-download="isInsurance" @close="closeTermDialog"/>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { createNamespacedHelpers } from "vuex";

import Gnb from "@/pages/components/layout/Gnb.vue";
import SafeguardGnb from "@/pages/components/layout/SafeguardGnb.vue";
import MainFooter from "@/pages/components/layout/MainFooter.vue";
import TermsDialog from "@/pages/components/TermsDialog"
import { isSafeguardHost } from "@/assets/js/safeguardSite";

const { mapGetters } = createNamespacedHelpers("ui");

export default {
  name: "BaseContainer",
  components: {
    Gnb,
    SafeguardGnb,
    MainFooter,
    TermsDialog
  },
  props: {
    subHeaderTitle: {
      type: String,
      default: ""
    },
    subHeaderText: {
      type: String,
      default: ""
    },
    subHeaderCaption: {
      type: String,
      default: ""
    },
    subHeaderImage: {
      type: String,
      default: "logo_pass.svg"
    },
    subHeaderAlign: {
      type: String,
      default: ""
    },
    subHeaderColor: {
      type: Boolean
    },
    layout: {
      type: String,
      default: "" // or main
    }
    ,
    fixFooter: {
      type: Boolean
    }
  },
  data() {
    return {
      isShowTermsDialog: false,
      termTitle: "",
      termContent: "",
      isExternalTerm: false,
      externalTermUrl: "",
      isInsurance: "",
      isSafeguardSite: isSafeguardHost()
    };
  },
  computed: {
    ...mapGetters(["isDimmed"]),
    isSub() {
      return this.layout !== "main";
    }
  },
  watch: {
    isDimmed(value) {
      const { dimmed } = this.$refs;

      if (value) {
        gsap.set(dimmed, { autoAlpha: 0, display: "none" });
        gsap.to(dimmed, 0.5, { autoAlpha: 1, display: "block" });
      } else {
        gsap.set(dimmed, { autoAlpha: 1, display: "block" });
        gsap.to(dimmed, 0.5, { autoAlpha: 0, display: "none" });
      }
    },
  },

  methods: {
    showTermDialog({termsCd, prdtNo, teleCoCd, isExternalTerm = false, externalTermUrl = "", mvnoYn}) {
      this.axios.post("/view/getTerms", {termsCd, prdtNo, teleCoCd, mvnoYn}).then(res => {
        if (res.data.resultCode === "S0000") {
          //약관 다운로드 버튼 제어하도록 추가
          this.isInsurance = termsCd === "114" ? true : false;

          this.termTitle = res.data.termsTitle;
          this.termContent = res.data.termsContent;
          this.isExternalTerm = isExternalTerm;
          this.externalTermUrl = externalTermUrl;
        } else {
          this.termTitle = "";
          this.termContent = res.data.resultMsg;
        }
        this.isShowTermsDialog = true;
      });
    },

    showPrimeTermDialog({termsCd, prdtNo = "P001", teleCoCd = "1"}) {
      this.axios.post(`${process.env.VUE_APP_PRIME_API}/myPrime/getTerms`, {
        condition: {
          teleCoCd,
          termsCd,
          prdtNo
        },
        transactionId: "''"
      }).then(res => {
        if (res.data.isSucceed) {
          this.termTitle = res.data.result.termsTitle;
          this.termContent = res.data.result.termsContent;
        } else {
          this.termTitle = "";
          this.termContent = res.data.resultMsg;
        }
        this.isShowTermsDialog = true;
      });
    },

    closeTermDialog() {
      this.isInsurance = false;
      this.termsTitle = "";
      this.termsContent = "";
      this.isExternalTerm = false;
      this.externalTermUrl = "";
      this.isShowTermsDialog = false;
    },
  },

  mounted() {
  },
  destroyed() {
  }
};
</script>

<style lang="scss" scoped>
.fix-footer{
    position: fixed;
    bottom: 0;
    right: 0px;
    left: 0px;
}
.sub-header {
  display: flex;
  align-items: center;
  padding: 100px 18px 50px;

  &.center {
    text-align: center;
    > div {
      margin: 0 auto;
    }
  }

  &-img {
    margin-left: 0;
    height: 12px;
  }

  &-title {
    font-size: rem(20px);
    line-height: rem(30px);
    letter-spacing: -1.5px;
    color: #006fbc;
    word-break: keep-all;
    &.text {
      color: #001523;
    }
  }

  &-text {
    margin-top: 24px;
    font-size: rem(13px);
    line-height: rem(22px);
    letter-spacing: -1px;
    word-break: keep-all;
  }

  &-caption {
    margin-top: 24px;
    font-size: rem(12px);
    line-height: rem(18px);
    letter-spacing: -1px;
    color: #ff0000;
    word-break: keep-all;
  }

  @include respond-to("small") {
    padding: 130px 30px 80px;
    &-img {
      margin-left: 4px;
      height: 20px;
    }
    &-title {
      font-size: rem(30px);
      line-height: rem(44px);
      letter-spacing: -2px;
    }
    &-text {
      font-size: rem(16px);
      line-height: rem(24px);
    }
  }

  @include respond-to("medium") {
    padding: 160px 0 100px;
    // 세이프가드 홈페이지는 헤더가 100px 이라 시안(타이틀 상단 238px, 하단 150px)에 맞춘다
    &.sub-header-safeguard {
      padding: 238px 0 150px;

      .sub-header-img {
        height: 30px;
      }

      .sub-header-title {
        margin-top: 16px;
        line-height: rem(40px);
      }

      .sub-header-text {
        margin-top: 25px;
      }
    }
    &-img {
      margin-left: 4px;
      height: 20px;
    }
    &-title {
      font-size: rem(40px);
      line-height: rem(60px);
      letter-spacing: -2px;
    }
    &-text {
      font-size: rem(18px);
      line-height: rem(30px);
    }
  }
}

</style>
